// StatusSteps.tsx — steps pasivos sin input del onboarding.
// Qué hace: renderiza los estados de espera/transición (greeting, scanning,
//   creating, document-analyzing) que solo muestran texto o el typing animado.
// Qué exporta: GreetingStep, ScanningStep, CreatingStep, DocumentAnalyzingStep.
// Quién lo usa: CreateWorkspaceModal.

import { TypingDots } from '../styled';

export function GreetingStep() {
  return (
    <div style={{ textAlign: 'center', padding: 8 }}>
      <TypingDots><span /><span /><span /></TypingDots>
    </div>
  );
}

export function ScanningStep() {
  return (
    <div style={{ textAlign: 'center', fontSize: 12, color: '#999', padding: 8 }}>
      Scanning in progress...
    </div>
  );
}

export function CreatingStep() {
  return (
    <div style={{ textAlign: 'center', fontSize: 12, color: '#999', padding: 8 }}>
      Setting up your workspace...
    </div>
  );
}

export function DocumentAnalyzingStep() {
  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <TypingDots><span /><span /><span /></TypingDots>
      <p style={{ color: '#64748B', fontSize: 13, marginTop: 8 }}>Reading your document...</p>
    </div>
  );
}
